var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation-bar'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pb-5 ml-auto bg-light pt-5"},[_c('div',{staticClass:"mx-4"},[_c('router-view')],1)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }